var slideIndex = 0;
// showDivs(slideIndex);
// plusDivs(1);
// next();
// carousel();

function plusDivs(n) {
  showDivs(slideIndex += n);
}

function next() {
  plusDivs(1);
}

function showDivs(n) {
  var i;
  var x = document.getElementsByClassName("mySlides");
  if (n > x.length) { slideIndex = 1 }
  if (n < 1) { slideIndex = x.length }
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
  }
  x[slideIndex - 1].style.display = "flex";
  x[slideIndex - 1].style.textAlign = "center";
  x[slideIndex - 1].style.justifyContent = "center";
}

function carousel() {
  setTimeout(carousel, 5000);
  next();
}

$(document).ready(function () {
  showDivs(slideIndex);
  carousel();
});